import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "./Layout/MainLayout";
import Page from "./component/Home/Page";
import AboutPage from "./component/About/AboutPage";
// import BlogPage from "./component/Blog/BlogPage";
// import BlogDetailPage from "./component/Blog/BlogDetailPage";
import CareerPage from "./component/Career/CareerPage";
import ContactPage from "./component/Contact/ContactPage";
import PrivacyPolicyPage from "./component/Legal/PrivacyPolicyPage";
import FaqPage from "./component/FAQ/FaqPage";
import Service from "./component/Service/Service";
import ServiceDetails from "./component/Service/ServiceDetails";

function App() {
  return (
    <BrowserRouter>

      <Routes>

        {/* Layout Wrapper */}
        <Route path="/" element={<MainLayout />}>

          {/* Pages */}
          <Route index element={<Page />} />
          <Route path="about" element={<AboutPage />} />
           <Route path="service" element={<Service />} />
           <Route path="/service/:id" element={<ServiceDetails />} />
          <Route path="career" element={<CareerPage />} />
          {/* <Route path="blog" element={<BlogPage />} />
          <Route path="blog/:slug" element={<BlogDetailPage />} /> */}
          <Route path="contact" element={<ContactPage />} />
          <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="faqs" element={<FaqPage />} />

        </Route>

      </Routes>

    </BrowserRouter>
  );
}

export default App;